export default __webpack_public_path__ + "static/media/second.b096c778.png";